import React from 'react';

export const CloseGraphIcon: React.FC = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                d="M18.0490208,4.33473511 C18.4953343,3.88842163 19.2189514,3.88842163 19.6652649,4.33473511 C20.1115784,4.78104858 20.1115784,5.5046657 19.6652649,5.95097918 L19.6652649,5.95097918 L13.616,12 L19.6652649,18.0490208 C20.0796988,18.4634548 20.1093013,19.1169924 19.7540722,19.565584 L19.6652649,19.6652649 C19.2189514,20.1115784 18.4953343,20.1115784 18.0490208,19.6652649 L18.0490208,19.6652649 L12,13.616 L5.95097918,19.6652649 C5.53654524,20.0796988 4.88300764,20.1093013 4.43441604,19.7540722 L4.33473511,19.6652649 C3.88842163,19.2189514 3.88842163,18.4953343 4.33473511,18.0490208 L4.33473511,18.0490208 L10.384,12 L4.33473511,5.95097918 C3.92030116,5.53654524 3.89069874,4.88300764 4.24592783,4.43441604 L4.33473511,4.33473511 C4.78104858,3.88842163 5.5046657,3.88842163 5.95097918,4.33473511 L5.95097918,4.33473511 L12,10.384 Z"
                id="path-1-close-graph"
            />
        </defs>
        <g
            id="Icons/Analytics/Closes-2/Resting"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2-close-graph" fill="white">
                <use xlinkHref="#path-1-close-graph" />
            </mask>
            <use
                id="close"
                fill="#42526E"
                fillRule="nonzero"
                xlinkHref="#path-1-close-graph"
            />
            <g
                className="hover-graph-icon"
                mask="url(#mask-2-close-graph)"
                fill="#9495A0"
            >
                <rect id="Color-Container" x={0} y={0} width={24} height={24} />
            </g>
        </g>
    </svg>
);

export const GoToFullScreenIcon = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                d="M10.71,13.29 C10.8993127,13.4777666 11.0057983,13.7333625 11.0057983,14 C11.0057983,14.2666375 10.8993127,14.5222334 10.71,14.71 L5.41,20 L8,20 C8.55228475,20 9,20.4477153 9,21 C9,21.5522847 8.55228475,22 8,22 L3,22 C2.44771525,22 2,21.5522847 2,21 L2,16 C2,15.4477153 2.44771525,15 3,15 C3.55228475,15 4,15.4477153 4,16 L4,18.59 L9.29,13.29 C9.4777666,13.1006873 9.73336246,12.9942017 10,12.9942017 C10.2666375,12.9942017 10.5222334,13.1006873 10.71,13.29 L10.71,13.29 Z M21,2 L16,2 C15.4477153,2 15,2.44771525 15,3 C15,3.55228475 15.4477153,4 16,4 L18.59,4 L13.29,9.29 C13.1006873,9.4777666 12.9942017,9.73336246 12.9942017,10 C12.9942017,10.2666375 13.1006873,10.5222334 13.29,10.71 C13.4777666,10.8993127 13.7333625,11.0057983 14,11.0057983 C14.2666375,11.0057983 14.5222334,10.8993127 14.71,10.71 L20,5.41 L20,8 C20,8.55228475 20.4477153,9 21,9 C21.5522847,9 22,8.55228475 22,8 L22,3 C22,2.44771525 21.5522847,2 21,2 Z"
                id="path-1-GFSI"
            />
        </defs>
        <g
            id="Icons/Analytics/FullScreen/Resting"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2-GFSI" fill="white">
                <use xlinkHref="#path-1-GFSI" />
            </mask>
            <use
                id="Shape"
                fill="#000000"
                fillRule="nonzero"
                xlinkHref="#path-1-GFSI"
            />
            <g className="hover-graph-icon" mask="url(#mask-2-GFSI)" fill="#9495A0">
                <rect id="Color-Container" x={0} y={0} width={24} height={24} />
            </g>
        </g>
    </svg>
);

export const RestoreIcon = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                d="M21.7019303,2.29806969 C21.8926966,2.4872781 22,2.74483662 22,3.0135216 C22,3.28220658 21.8926966,3.5397651 21.7019303,3.72897352 L16.3612329,9.05959413 L18.9711209,9.05959413 C19.5276465,9.05959413 19.9787996,9.51074727 19.9787996,10.0672729 C19.9787996,10.6237985 19.5276465,11.0749516 18.9711209,11.0749516 L13.9327271,11.0749516 C13.3762015,11.0749516 12.9250484,10.6237985 12.9250484,10.0672729 L12.9250484,5.02887911 C12.9250484,4.4723535 13.3762015,4.02120036 13.9327271,4.02120036 C14.4892527,4.02120036 14.9404059,4.4723535 14.9404059,5.02887911 L14.9404059,7.63876708 L20.2710265,2.29806969 C20.4602349,2.10730335 20.7177934,2 20.9864784,2 C21.2551634,2 21.5127219,2.10730335 21.7019303,2.29806969 L21.7019303,2.29806969 Z M10.0672729,12.9250484 L5.02887911,12.9250484 C4.4723535,12.9250484 4.02120036,13.3762015 4.02120036,13.9327271 C4.02120036,14.4892527 4.4723535,14.9404059 5.02887911,14.9404059 L7.63876708,14.9404059 L2.29806969,20.2710265 C2.10730335,20.4602349 2,20.7177934 2,20.9864784 C2,21.2551634 2.10730335,21.5127219 2.29806969,21.7019303 C2.4872781,21.8926966 2.74483662,22 3.0135216,22 C3.28220658,22 3.5397651,21.8926966 3.72897352,21.7019303 L9.05959413,16.3612329 L9.05959413,18.9711209 C9.05959413,19.5276465 9.51074727,19.9787996 10.0672729,19.9787996 C10.6237985,19.9787996 11.0749516,19.5276465 11.0749516,18.9711209 L11.0749516,13.9327271 C11.0749516,13.3762015 10.6237985,12.9250484 10.0672729,12.9250484 Z"
                id="path-1-RIC"
            />
        </defs>
        <g
            id="Icons/Analytics/Restore/Resting"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2-RIC" fill="white">
                <use xlinkHref="#path-1-RIC" />
            </mask>
            <use
                id="Shape"
                fill="#000000"
                fillRule="nonzero"
                xlinkHref="#path-1-RIC"
            />
            <g className="hover-graph-icon" mask="url(#mask-2-RIC)" fill="#9495A0">
                <rect id="Color-Container" x={0} y={0} width={24} height={24} />
            </g>
        </g>
    </svg>
);

export const MoveIcon = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                d="M21.7906706,11.4950023 L18.9335405,8.63787215 C18.6544346,8.35876626 18.2024723,8.35876626 17.923545,8.63787215 C17.6446177,8.91697805 17.6444391,9.36894032 17.923545,9.64786764 L19.5613948,11.2857175 L12.7142825,11.2857175 L12.7142825,4.43860518 L14.3521324,6.07645502 C14.491596,6.21591868 14.6744523,6.2857398 14.8571301,6.2857398 C15.0398079,6.2857398 15.2226642,6.21591868 15.3621278,6.07645502 C15.6412337,5.79734912 15.6412337,5.34538685 15.3621278,5.06645952 L12.5049977,2.20932942 C12.2258918,1.93022353 11.7739296,1.93022353 11.4950023,2.20932942 L8.63787215,5.06645952 C8.35876626,5.34556542 8.35876626,5.79752769 8.63787215,6.07645502 C8.91697805,6.35538234 9.36894032,6.35556091 9.64786764,6.07645502 L11.2857175,4.43860518 L11.2857175,11.2857175 L4.43860518,11.2857175 L6.07645502,9.64786764 C6.35556091,9.36876175 6.35556091,8.91679948 6.07645502,8.63787215 C5.79734912,8.35894483 5.34538685,8.35876626 5.06645952,8.63787215 L2.20932942,11.4950023 C1.93022353,11.7741082 1.93022353,12.2260704 2.20932942,12.5049977 L5.06645952,15.3621278 C5.20592319,15.5015915 5.38877951,15.5714126 5.57145727,15.5714126 C5.75413503,15.5714126 5.93699135,15.5015915 6.07645502,15.3621278 C6.35556091,15.083022 6.35556091,14.6310597 6.07645502,14.3521324 L4.43860518,12.7142825 L11.2857175,12.7142825 L11.2857175,19.5613948 L9.64786764,17.923545 C9.36876175,17.6444391 8.91679948,17.6444391 8.63787215,17.923545 C8.35894483,18.2026509 8.35876626,18.6546131 8.63787215,18.9335405 L11.4950023,21.7906706 C11.6344659,21.9301342 11.8173222,21.9999554 12,21.9999554 C12.1826778,21.9999554 12.3655341,21.9301342 12.5049977,21.7906706 L15.3621278,18.9335405 C15.6412337,18.6544346 15.6412337,18.2024723 15.3621278,17.923545 C15.083022,17.6446177 14.6310597,17.6444391 14.3521324,17.923545 L12.7142825,19.5613948 L12.7142825,12.7142825 L19.5613948,12.7142825 L17.923545,14.3521324 C17.6444391,14.6312383 17.6444391,15.0832005 17.923545,15.3621278 C18.0630086,15.5015915 18.245865,15.5714126 18.4285427,15.5714126 C18.6112205,15.5714126 18.7940768,15.5015915 18.9335405,15.3621278 L21.7906706,12.5049977 C22.0697765,12.2260704 22.0697765,11.7739296 21.7906706,11.4950023 Z"
                id="path-1-MIC"
            />
        </defs>
        <g
            id="Icons/Analytics/Move/Resting"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2-MIC" fill="white">
                <use xlinkHref="#path-1-MIC" />
            </mask>
            <use
                id="Move"
                fill="#000000"
                fillRule="nonzero"
                xlinkHref="#path-1-MIC"
            />
            <g className="hover-graph-icon" mask="url(#mask-2-MIC)" fill="#9495A0">
                <rect id="Color-Container" x={0} y={0} width={24} height={24} />
            </g>
        </g>
    </svg>
);

export const SettingsIcon = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                d="M12,10.5 C11.173,10.5 10.5,11.173 10.5,12 C10.5,12.827 11.173,13.5 12,13.5 C12.827,13.5 13.5,12.827 13.5,12 C13.5,11.173 12.827,10.5 12,10.5 M12,15.5 C10.07,15.5 8.5,13.93 8.5,12 C8.5,10.07 10.07,8.5 12,8.5 C13.93,8.5 15.5,10.07 15.5,12 C15.5,13.93 13.93,15.5 12,15.5 M20.317,9.375 L19.233,9.375 C19.086,9.375 18.986,9.258 18.925,9.111 C18.879,9 18.867,8.846 18.972,8.741 L19.742,7.975 C20.06,7.658 20.236,7.235 20.236,6.787 C20.236,6.337 20.062,5.915 19.744,5.598 L18.403,4.257 C17.749,3.601 16.682,3.603 16.026,4.257 L15.256,5.028 C15.152,5.133 14.998,5.12 14.853,5.06 C14.743,5.015 14.625,4.914 14.625,4.767 L14.625,3.676 C14.625,2.752 13.874,2 12.949,2 L11.057,2 C10.129,2 9.375,2.755 9.375,3.683 L9.375,4.767 C9.375,4.914 9.258,5.014 9.111,5.075 C9,5.122 8.845,5.134 8.741,5.028 L7.976,4.259 C7.658,3.94 7.236,3.765 6.787,3.765 L6.785,3.765 C6.336,3.765 5.914,3.939 5.597,4.257 L4.257,5.597 C3.602,6.251 3.602,7.317 4.257,7.974 L5.028,8.744 C5.132,8.848 5.12,9.003 5.06,9.147 C5.015,9.257 4.914,9.375 4.767,9.375 L3.676,9.375 C2.752,9.375 2,10.126 2,11.051 L2,12.943 C2,13.871 2.755,14.625 3.683,14.625 L4.767,14.625 C4.914,14.625 5.014,14.742 5.075,14.889 C5.121,15 5.133,15.154 5.028,15.259 L4.259,16.024 C3.94,16.342 3.765,16.764 3.765,17.213 C3.764,17.663 3.939,18.085 4.257,18.403 L5.597,19.743 C6.251,20.399 7.318,20.397 7.974,19.743 L8.744,18.972 C8.849,18.869 9.003,18.881 9.147,18.94 C9.257,18.985 9.375,19.086 9.375,19.233 L9.375,20.324 C9.375,21.248 10.126,22 11.051,22 L12.943,22 C13.871,22 14.625,21.245 14.625,20.317 L14.625,19.233 C14.625,19.086 14.742,18.986 14.889,18.925 C14.999,18.879 15.154,18.867 15.259,18.972 L16.024,19.741 C16.342,20.06 16.764,20.235 17.213,20.235 L17.215,20.235 C17.664,20.235 18.086,20.061 18.403,19.743 L19.743,18.403 C20.398,17.749 20.398,16.683 19.743,16.026 L18.972,15.256 C18.868,15.152 18.88,14.997 18.927,14.886 C18.927,14.884 18.94,14.854 18.94,14.853 C18.985,14.743 19.086,14.625 19.233,14.625 L20.324,14.625 C21.248,14.625 22,13.874 22,12.949 L22,11.057 C22,10.129 21.245,9.375 20.317,9.375"
                id="path-1-SIC"
            />
        </defs>
        <g
            id="Icons/Analytics/Settings/Resting"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2-SIC" fill="white">
                <use xlinkHref="#path-1-SIC" />
            </mask>
            <use id="🎨-Icon-Сolor" fill="#222B45" xlinkHref="#path-1-SIC" />
            <g id="↳-🎨Color/Neutral/300" mask="url(#mask-2-SIC)" fill="#9495A0">
                <rect id="Color-Container" x={0} y={0} width={24} height={24} />
            </g>
        </g>
    </svg>
);

export const ColorPickerIcon = () => {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width={16} height={16} rx={16} fill="#fff" />
        </svg>
    );
};

export const MinimiseIcon = () => (
    <svg
        width="16px"
        height="16px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M11.2838457,12.253025 L4.42657735,17.7704163 C3.93513979,18.1669645 3.8562812,18.8857795 4.25285989,19.3771793 C4.64943857,19.8697219 5.36830887,19.9474316 5.85974644,19.5508834 L11.9878586,14.6208864 L18.1262566,19.7348727 C18.3399748,19.9131479 18.5994082,20 18.8565557,20 C19.1845617,20 19.5091391,19.8605796 19.7354289,19.5885955 C20.1388649,19.1040525 20.0737208,18.3840946 19.5891405,17.9795469 L12.7318722,12.2655957 C12.3135788,11.9159019 11.7078535,11.9113308 11.2838457,12.253025 Z M11.2831998,4.25243561 L4.42608824,9.76943279 C3.93466191,10.1659527 3.85694798,10.8847164 4.25237475,11.3772238 C4.64894437,11.8685885 5.36779823,11.9462927 5.85922457,11.5509155 L11.9871966,6.62012785 L18.1254544,11.7348916 C18.3391677,11.9120114 18.5985951,12 18.8568796,12 C19.1837353,12 19.5083052,11.8594468 19.7345899,11.5886249 C20.1391595,11.1029737 20.0740169,10.3830673 19.5883048,9.97969117 L12.7311932,4.26614811 C12.3129094,3.91533657 11.7071979,3.91190844 11.2831998,4.25243561 Z"
                id="path-1-MIMC"
            />
        </defs>
        <g
            id="Icons/Console/arrowhead-up"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2-MIMC" fill="#9495A0">
                <use xlinkHref="#path-1-MIMC" />
            </mask>
            <use id="🎨-Icon-Сolor" fill="#6D707E" xlinkHref="#path-1-MIMC" />
            <g id="↳-🎨Color/Neutral/100" mask="url(#mask-2-MIMC)" fill="#D4D6E0">
                <rect id="Color-Container" x={0} y={0} width={24} height={24} />
            </g>
        </g>
    </svg>
);

export function GoBackArrow() {
    return (
        <svg width={20} height={20} viewBox="0 0 20 20" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.187 5.843L6.197 9.17h10.47v1.663H6.197l2.99 3.326-1.057 1.176L3.333 10 8.13 4.667l1.057 1.176z"
                fill="#9495A0"
            />
            <mask
                id="GBA"
                maskUnits="userSpaceOnUse"
                x={3}
                y={4}
                width={14}
                height={12}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.187 5.843L6.197 9.17h10.47v1.663H6.197l2.99 3.326-1.057 1.176L3.333 10 8.13 4.667l1.057 1.176z"
                    fill="#fff"
                />
            </mask>
            <g mask="url(#GBA)">
                <path fill="#1E2038" d="M0 0H20V20H0z" />
            </g>
        </svg>
    );
}

export const EyeIcon = () => {
    return(
        (
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.948 11.757c-.026-.06-.661-1.468-2.074-2.881C16.993 6.995 14.616 6 12 6c-2.616 0-4.993.995-6.874 2.876-1.413 1.413-2.048 2.822-2.074 2.88a.6.6 0 000 .488c.026.06.661 1.468 2.074 2.88C7.007 17.007 9.384 18 12 18c2.616 0 4.993-.994 6.874-2.875 1.413-1.413 2.048-2.821 2.074-2.88a.6.6 0 000-.488zM12 9.3a2.7 2.7 0 110 5.4 2.7 2.7 0 010-5.4z"
                fill="#D4D6E0"
              />
            </svg>
          )
    )
}

export const EyeSlashIcon = () => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.957 11.797c-.022-.049-.551-1.223-1.728-2.4C16.66 7.829 14.68 7 12.5 7c-.46 0-.92.037-1.374.112a.5.5 0 00-.288.83l6.33 6.963a.5.5 0 00.704.036c1.426-1.277 2.059-2.678 2.085-2.738a.5.5 0 000-.406zM7.87 6.164a.5.5 0 10-.74.672L8.333 8.16c-2.27 1.393-3.246 3.54-3.29 3.638a.5.5 0 000 .407c.022.049.551 1.223 1.728 2.4C8.34 16.17 10.321 17 12.5 17a7.936 7.936 0 003.254-.677l1.376 1.513a.5.5 0 10.74-.672l-10-11zm4.63 8.086a2.249 2.249 0 01-1.845-3.536l2.95 3.245a2.236 2.236 0 01-1.105.291z"
        fill="#9495A0"
      />
    </svg>
)

export const RasterSettingsIcon = () => (
    <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.76 9.887a1.362 1.362 0 00-.248-.528c-.12-.154-.27-.28-.442-.367l-1.165-.599-.448-.807.083-1.349a1.388 1.388 0 00-.084-.581 1.344 1.344 0 00-.316-.487 8.652 8.652 0 00-3.52-2.113 1.242 1.242 0 00-1.09.174l-1.082.75h-.896l-1.082-.75a1.241 1.241 0 00-1.09-.174A8.653 8.653 0 005.86 5.17a1.344 1.344 0 00-.316.487c-.069.185-.098.383-.084.581l.083 1.349-.448.807-1.165.6a1.299 1.299 0 00-.442.366c-.12.155-.204.335-.248.528a9.422 9.422 0 000 4.225c.044.193.129.374.248.528.12.155.27.28.442.367l1.165.6.448.806-.083 1.35c-.014.197.015.396.084.58.07.185.178.352.316.488a8.653 8.653 0 003.52 2.113 1.241 1.241 0 001.09-.174l1.082-.75h.896l1.082.75c.214.15.465.23.723.23.124 0 .248-.019.367-.056a8.654 8.654 0 003.52-2.113c.138-.136.246-.303.316-.487.069-.185.098-.384.084-.581l-.083-1.35.448-.806 1.165-.6c.172-.086.323-.212.442-.367.12-.154.204-.335.248-.528a9.42 9.42 0 000-4.225zM15.857 12c0 .793-.226 1.568-.65 2.228a3.893 3.893 0 01-1.73 1.477 3.72 3.72 0 01-2.23.228 3.814 3.814 0 01-1.974-1.098 4.062 4.062 0 01-1.056-2.053 4.158 4.158 0 01.22-2.317 3.98 3.98 0 011.42-1.8A3.753 3.753 0 0112 7.99a3.788 3.788 0 012.726 1.176A4.097 4.097 0 0115.857 12z"
      fill="#D4D6E0"
    />
  </svg>
)


export const PaintBrushIcon = () => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.333 3h-12A3.337 3.337 0 004 6.333v6a2.002 2.002 0 002 2h3.898L9.34 18.24a.665.665 0 00-.007.094 2.667 2.667 0 105.334 0 .677.677 0 00-.007-.094l-.558-3.906H18a2.002 2.002 0 002-2V3.667A.666.666 0 0019.333 3zm-12 1.333H16v3.334a.666.666 0 101.333 0V4.333h1.334v5.334H5.333V6.333a2.002 2.002 0 012-2z"
        fill="#D4D6E0"
      />
    </svg>
)

export const DeleteFilledIcon = () => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4 5.862c0-.124.171-.262.4-.262h2.4c.229 0 .4.138.4.262V7.2h-3.2V5.862zM19.2 7.2h-4V5.862c0-1.027-.897-1.862-2-1.862h-2.4c-1.103 0-2 .835-2 1.862V7.2h-4c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h.8v8.8C5.6 18.924 6.677 20 8 20h8c1.323 0 2.4-1.076 2.4-2.4V8.8h.8c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8z"
        fill="#000"
      />
      <mask
        id="DeleteFilledIcon"
        style={{
          maskType: "alpha"
        }}
        maskUnits="userSpaceOnUse"
        x={4}
        y={4}
        width={16}
        height={16}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4 5.862c0-.124.171-.262.4-.262h2.4c.229 0 .4.138.4.262V7.2h-3.2V5.862zM19.2 7.2h-4V5.862c0-1.027-.897-1.862-2-1.862h-2.4c-1.103 0-2 .835-2 1.862V7.2h-4c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h.8v8.8C5.6 18.924 6.677 20 8 20h8c1.323 0 2.4-1.076 2.4-2.4V8.8h.8c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#DeleteFilledIcon)">
        <path fill="#D4D6E0" d="M0 0H24V24H0z" />
      </g>
    </svg>
)

export function AddRasterPlusIcon() {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.667 8A5.34 5.34 0 018 2.667 5.34 5.34 0 0113.334 8 5.34 5.34 0 018 13.333 5.34 5.34 0 012.667 8zm5.744.41h2.153a.41.41 0 000-.82H8.411V5.538a.41.41 0 00-.82 0V7.59H5.435a.41.41 0 000 .82H7.59v2.256a.41.41 0 00.82 0V8.41z"
          fill="#000"
        />
        <mask
          id="a-AddRasterPlusIcon"
          style={{
            maskType: "alpha"
          }}
          maskUnits="userSpaceOnUse"
          x={2}
          y={2}
          width={12}
          height={12}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.667 8A5.34 5.34 0 018 2.667 5.34 5.34 0 0113.334 8 5.34 5.34 0 018 13.333 5.34 5.34 0 012.667 8zm5.744.41h2.153a.41.41 0 000-.82H8.411V5.538a.41.41 0 00-.82 0V7.59H5.435a.41.41 0 000 .82H7.59v2.256a.41.41 0 00.82 0V8.41z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#a-AddRasterPlusIcon)">
          <path fill="#FCAD01" d="M0 0H16V16H0z" />
        </g>
      </svg>
    )
  }